import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo-pdf.png'


const _withScopeId = n => (_pushScopeId("data-v-068ca255"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "view-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "heading-title" }, "Credit/Debit Card", -1))
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "view-container"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "heading-title" }, "Credit/Debit Card", -1))
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 1,
  class: "payment-total-row"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "total-label total-col" }, "Total", -1))
const _hoisted_9 = { class: "total-value total-col" }
const _hoisted_10 = {
  key: 2,
  class: "saved-cards-container"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Saved Cards", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "heading-subtitle" }, " Please select from one of the saved cards or click 'New Credit/Debit card' to use a different card. ", -1))
const _hoisted_13 = { class: "saved-card-list-container" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "card-display-text" }
const _hoisted_16 = { class: "card-last-four-digits" }
const _hoisted_17 = { key: "newCard" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-display-text" }, " New Credit/Debit card ", -1))
const _hoisted_19 = {
  key: 0,
  class: "payment-element",
  id: "payment-element"
}
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group mb-3" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "cardNumber",
  class: "form-label"
}, "Card Number", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "card-number",
  class: "form-control"
}, null, -1))
const _hoisted_25 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_26 = { class: "is-invalid" }
const _hoisted_27 = { class: "col-md-3" }
const _hoisted_28 = { class: "form-group mb-3" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "cardExpiration",
  class: "form-label"
}, "Expiration", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "card-expiration",
  class: "form-control"
}, null, -1))
const _hoisted_31 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_32 = { class: "is-invalid" }
const _hoisted_33 = { class: "col-md-3" }
const _hoisted_34 = { class: "form-group mb-3" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "cardCVC",
  class: "form-label"
}, "CVC", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "card-cvc",
  class: "form-control"
}, null, -1))
const _hoisted_37 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_38 = { class: "is-invalid" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stripe-terms" }, [
  /*#__PURE__*/_createElementVNode("p", null, " By providing your card information, you allow P&A Administrative Services, Inc. to charge your card for future payments in accordance with their terms. ")
], -1))
const _hoisted_40 = {
  key: 2,
  class: "view-container"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "heading-title" }, "Credit/Debit Card", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " We have already received payment from you for this enrollment. Please click \"Submit\" to continue. ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" If you have any questions or concerns, please contact us here: "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://padmin.com/contact/",
    target: "_blank"
  }, "Click Here"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_44 = [
  _hoisted_41,
  _hoisted_42,
  _hoisted_43
]
const _hoisted_45 = {
  id: "pdfContentContainer",
  style: {"display":"none"}
}
const _hoisted_46 = { id: "pdfContent" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "pdf-logo"
}, null, -1))
const _hoisted_48 = {
  class: "heading-title-for-print",
  id: "print-title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_ConfirmationSave = _resolveComponent("ConfirmationSave")!
  const _component_ConfirmationTable = _resolveComponent("ConfirmationTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ((!_ctx.isStripeEnabled && _ctx.validationMsg) || _ctx.cardNotSelected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          (_ctx.validationMsg)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "alert alert-danger",
                innerHTML: _ctx.validationMsg
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true)
        ]))
      : (!_ctx.isPayed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            (_ctx.validationMsg)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "alert alert-danger",
                  innerHTML: _ctx.validationMsg
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            (
        _ctx.paymentSummary?.getAmountDueToday?.payMethod ===
        _ctx.common.paymentMethods.Card
      )
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, " $" + _toDisplayString(_ctx.helper.formatNumber(_ctx.totalAmount)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.savedCards && _ctx.savedCards.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _hoisted_12,
                  _createElementVNode("ul", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.savedCards, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.paymentMethodId
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          name: "item.paymentMethodId",
                          value: item.paymentMethodId,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCardId) = $event))
                        }, null, 8, _hoisted_14), [
                          [_vModelRadio, _ctx.selectedCardId]
                        ]),
                        _createElementVNode("span", _hoisted_15, [
                          _createTextVNode(_toDisplayString(item.cardType) + " ", 1),
                          _createElementVNode("span", _hoisted_16, " ********" + _toDisplayString(item.last4), 1)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-link remove-card-btn",
                          "aria-label": "delete card",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteCardDetail(_ctx.selectedCardId)))
                        }, " remove ")
                      ]))
                    }), 128)),
                    _createElementVNode("li", _hoisted_17, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        name: "newCard",
                        value: 0,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCardId) = $event)),
                        onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onCardChange && _ctx.onCardChange(...args)))
                      }, null, 544), [
                        [_vModelRadio, _ctx.selectedCardId]
                      ]),
                      _hoisted_18
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(
        _ctx.selectedCardId === 0 || !(_ctx.savedCards?.length > 0)
          ? 'new-card-container'
          : ''
      )
            }, [
              _createElementVNode("div", null, [
                (
            (_ctx.paymentSummary?.getAmountDueToday?.payMethod ===
              _ctx.common.paymentMethods.Card &&
              _ctx.selectedCardId === 0) ||
            !(_ctx.savedCards?.length > 0)
          )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19))
                  : _createCommentVNode("", true),
                (
            _ctx.paymentSummary?.getAmountDueToday?.payMethod !==
              _ctx.common.paymentMethods.Card &&
            _ctx.paymentSummary?.getMonthlyPremium?.payMethod ===
              _ctx.common.paymentMethods.Card
          )
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["card-element", { 'd-none': !_ctx.cardNumber }])
                    }, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _hoisted_24,
                            (_ctx.cardNumberError)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.cardNumberError), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _hoisted_29,
                            _hoisted_30,
                            (_ctx.cardExpiryError)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                  _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.cardExpiryError), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _hoisted_35,
                            _hoisted_36,
                            (_ctx.cardCvcError)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                  _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.cardCvcError), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _hoisted_39
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true),
    (_ctx.isPayed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_44))
      : _createCommentVNode("", true),
    _createVNode(_component_AppFooter, {
      "save-btn-txt": _ctx.submitText(),
      "selected-saved-card-id": _ctx.selectedCardId,
      "is-form-invalid": !_ctx.elements && _ctx.isPayed === false,
      "is-submit-disabled": 
      _ctx.isLoading || (!_ctx.shouldModalVisible() && _ctx.isPayed === false)
    ,
      onSubmitHandler: _ctx.handleSubmit
    }, null, 8, ["save-btn-txt", "selected-saved-card-id", "is-form-invalid", "is-submit-disabled", "onSubmitHandler"]),
    _createVNode(_component_ConfirmationSave, {
      visible: _ctx.showConfirmationModal,
      onClose: _ctx.closeConfirmationModal,
      onConfirmEnrollment: _ctx.confirmEnrollment
    }, null, 8, ["visible", "onClose", "onConfirmEnrollment"]),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("div", _hoisted_46, [
        _hoisted_47,
        _createElementVNode("h1", _hoisted_48, " Your confirmation number is " + _toDisplayString(_ctx.profileData.electionId), 1),
        _createVNode(_component_ConfirmationTable, {
          "profile-data": _ctx.profileData,
          "qualifying-beneficiary-data": _ctx.qualifyingBeneficiaryData,
          "get-state-name": _ctx.getStateName,
          "get-country-name": _ctx.getCountryName,
          "dependent-data": _ctx.dependentData,
          "benefits-data": _ctx.benefitsData,
          "monthly-premium-data": _ctx.monthlyPremiumData,
          "get-monthly-country-name": _ctx.getMonthlyCountryName,
          "get-monthly-state-name": _ctx.getMonthlyStateName,
          "amount-today-data": _ctx.amountTodayData,
          "documents-data": _ctx.documentsData,
          "modify-btn": false,
          "gender-options": _ctx.genderOptions,
          countries: _ctx.countries,
          "payment-methods": _ctx.paymentMethods,
          "account-types": _ctx.accountTypes,
          "card-detail": _ctx.cardDetail
        }, null, 8, ["profile-data", "qualifying-beneficiary-data", "get-state-name", "get-country-name", "dependent-data", "benefits-data", "monthly-premium-data", "get-monthly-country-name", "get-monthly-state-name", "amount-today-data", "documents-data", "gender-options", "countries", "payment-methods", "account-types", "card-detail"])
      ])
    ])
  ], 64))
}